export default {
  timeout: 6000,
  timeoutMsg: "请求超时",
  tokenKey: "AUTH_TOKEN",
  baseUrl: "/api-admin",
  uploadUrl: "/upload",
  ipUrl: "/ip",
  status: {
    200: 200,
    400: 400,
    401: 401,
    402: 402,
    403: 403,
    404: 404,
    405: 405,
    406: 406,
    407: 407,
    408: 408,
    500: 500,
    501: 501,
    502: 502,
    503: 503,
    504: 504,
    505: 505,
  },
};
